import { resolveImagePath } from '@/utils/imageMap';

export function HeroSection() {
  const logoSrc = resolveImagePath('/images/logo.png');
  const backgroundSrc = resolveImagePath('/images/helicopter-background.jpg');

  return (
    <section 
      className="relative min-h-screen flex flex-col justify-center items-center text-center text-white"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${backgroundSrc})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto px-4 py-20">
        {/* Logo */}
        <div className="mb-12">
          <img 
            src={logoSrc} 
            alt="Thoroughbred Aviation Maintenance" 
            className="mx-auto h-40 w-auto"
          />
        </div>

        {/* Tagline */}
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-lg md:text-xl leading-relaxed">
            Providing mobile and on-site aviation maintenance and parts.<br />
            Locations at Danville, Somerset, Georgetown, Richmond, Lexington,<br />
            and Big Sandy Airports.
          </p>
        </div>

      </div>

      {/* Latest News Ticker */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 w-full max-w-5xl mx-auto px-4">
        <div className="bg-blue-800/95 backdrop-blur-sm rounded p-3">
          <div className="flex items-center">
            <div className="text-white font-semibold mr-6 text-sm whitespace-nowrap">
              Latest News
            </div>
            <div className="flex-1 overflow-hidden">
              <div className="flex animate-scroll">
                <div className="whitespace-nowrap mx-6">
                  <a 
                    href="/hai-member-spotlight/" 
                    className="text-white hover:text-blue-200 transition-colors text-sm"
                  >
                    HAI Member Spotlight: Thoroughbred Aviation Maintenance
                  </a>
                </div>
                <div className="whitespace-nowrap mx-6">
                  <a 
                    href="/pmi1-pmi2-inspections-black-hawk/" 
                    className="text-white hover:text-blue-200 transition-colors text-sm"
                  >
                    Black Hawk Inspections: PMI-1 and PMI-2
                  </a>
                </div>
                <div className="whitespace-nowrap mx-6">
                  <a 
                    href="/cleetus-macfarland-md500-project/" 
                    className="text-white hover:text-blue-200 transition-colors text-sm"
                  >
                    Cleetus McFarland's MD500 Project
                  </a>
                </div>
              </div>
            </div>
            <div className="flex space-x-1 ml-4">
              <button className="text-white hover:text-blue-200 px-2 py-1 text-lg">
                <span className="sr-only">Previous</span>
                <span>‹</span>
              </button>
              <button className="text-white hover:text-blue-200 px-2 py-1 text-lg">
                <span className="sr-only">Next</span>
                <span>›</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}